import React, { useEffect } from 'react';
import './ChartModal.css';

/**
 * Modal component for displaying charts in fullscreen
 */
const ChartModal = ({ isOpen, onClose, children }) => {
  // Close on Escape key
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape' && isOpen) {
        onClose();
      }
    };

    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [isOpen, onClose]);

  // Prevent body scroll when modal is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="chart-modal-overlay" onClick={onClose}>
      <div className="chart-modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="chart-modal-close" onClick={onClose}>
          ✕
        </button>
        <div className="chart-modal-body">
          {children}
        </div>
      </div>
    </div>
  );
};

export default ChartModal;




